import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import Paginator from "./Pagination";
import { awaitManualPricing } from "../service/api";
import { ManualPricingTableHeading } from "../Utils/appConstants";
import SortIcon from "../assets/WebFont/sort.svg";
import { TableSortLabel } from "@material-ui/core";

const useStyles = makeStyles({
  table: {
    border: "1px solid #e1e1e1",
  },
  tableRow: {
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeaderRow: {
    borderTop: "1px solid #e1e1e1",
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeadFont: {
    fontWeight: 600,
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
  },
});


export default function ManualPricing(props) {
  const classes = useStyles();
  const [manualPricingList, setManualPricingList] = useState([]);
  const [manualPricingListRows, setManualPricingListRows] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('vin');
  const [curentDataPage, setCurrentDataPage] = useState(1);
  useEffect(() => {
    getManualPricingDetails();
  }, []);

  useEffect(() => {
    if (manualPricingListRows.length > 0 && curentDataPage === 1) {
      const updatedData = stableSort(manualPricingListRows, getComparator(order, orderBy));
      setManualPricingListRows(updatedData);
    }
  }, [order, orderBy]);
  async function getManualPricingDetails() {
    let apiResponse = await awaitManualPricing();
    setManualPricingListRows(apiResponse?.data?.sort((a, b) => (b?.inspectionDate > a?.inspectionDate) ? 1 : -1));
  }

  const openConditionReport = (VINumber, vehicle) => {
    props.props.history.push("/conditionreportRequests", {
      vin: VINumber,
      pageName: "Manual Pricing",
      purchaseSection: false,
      vehicleDetails: vehicle,
    });
  };

  const onChangePage = (data) => {
    if (data.length > 0) {
      setManualPricingList(data);
    }
  };

  const handleRequestSort = (
    property
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }


  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  return (
    <>
      <div>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead className={classes.tableHeaderRow}>
              <TableRow className={classes.tableHeadFont}>
                {curentDataPage === 1 ? ManualPricingTableHeading.map((item) => {
                  return (
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === item.id}
                        direction={orderBy === item.id ? order : 'asc'}
                        onClick={() => handleRequestSort(item.id)}
                        IconComponent={() => (
                          <img src={SortIcon} alt="sort" className="tableSortIcon" />
                        )}
                      >
                        {item.label}
                      </TableSortLabel>
                    </TableCell>
                  )
                }) : ManualPricingTableHeading.map((item) => {
                  return (
                    <TableCell>
                      {item.label}
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {manualPricingList
                .map((row, index) => (
                  <TableRow key={index} className={classes.tableRow}>
                    <TableCell>
                      <span className="textStyle">
                        <a href
                          className="vin"
                          onClick={() => openConditionReport(row.vin, row)}
                        >
                          {" "}
                          {row.vin}
                        </a>
                      </span>
                    </TableCell>
                    <TableCell>{row.modelYear}</TableCell>
                    <TableCell>{row.make}</TableCell>
                    <TableCell>{row.model}</TableCell>
                    <TableCell>{row.groundingRegion === "N/A" ? "" : row.groundingRegion}</TableCell>
                    <TableCell>
                      {row?.inspectionDate &&
                        `${moment(row?.inspectionDate).format("MM/DD/YYYY")} ${moment(row?.inspectionDate).format("hh:mm a")}`}
                    </TableCell>
                    <TableCell>{
                      row.inspectionStatus.toLowerCase().split(' ').map(function (word) { return word.replace(word[0], word[0].toUpperCase()); })}
                    </TableCell>
                    <TableCell>{row.auctionCode}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        {manualPricingListRows?.length !== 0 ? (
          <Paginator
            label="Result per page"
            showItemsPerPage={10}
            pages={[10, 20, 30, 40]}
            data={manualPricingListRows}
            onChangePage={onChangePage}
            setCurrentDataPage={setCurrentDataPage}
          />
        ) : null}
      </div>
    </>
  );
}
